import { useQuery } from 'react-query'
import { getAppConfigSetting } from '../utils'
import { SENTINEL_API } from './constants'
import axios from 'axios'
import { DateTime } from 'luxon'

const baseUrl = getAppConfigSetting('apiUrl')
const recentTransfersURL = `${baseUrl}${SENTINEL_API}`

type AccountNumber = string | undefined

export default function useGetRecentActivity(accountNumber: AccountNumber) {
  const getRecentTransfers = async () => {
    const twoWeeksAgo = DateTime.local().minus({ weeks: 2 })
    const today = DateTime.local()

    // show the previous two weeks of transfers
    const startDate = twoWeeksAgo.startOf('day').toUTC().toISO()
    const endDate = today.endOf('day').toUTC().toISO()

    return await axios.get(`${recentTransfersURL}/transfers/${accountNumber}`, {
      params: { since: startDate, before: endDate },
      withCredentials: true
    })
  }

  return useQuery(['recent-transfers', accountNumber], getRecentTransfers, { enabled: !!accountNumber })
}
